import React from "react";
import PropTypes from "prop-types";
import { Settings } from "lucide-react";
import StreamThumbnailCard from "../../../../components/cards/thumbnails/StreamThumbnailCard";

import "./StreamVideosGrid.css";

const StreamVideosGrid = ({
  streams = [],
  selectedInfoStream,
  getStreamId,
  getStatus,
  canPlayStream,
  getStreamImage,
  getStreamDetailText,
  getBadgeLabel,
  getBadgeVariant,
  getInfoModalTitle,
  getInfoModalMessage,
  getInfoModalMeta,
  onCardClick,
  onSettingsClick,
  onCloseInfoModal,
}) => {
  return (
    <div className="stream-videos-grid">
      {streams.map((stream) => {
        const streamSessionId = getStreamId(stream);
        const status = getStatus(stream);
        const canPlay = canPlayStream(stream);

        const infoModalOpen =
          getStreamId(selectedInfoStream) === streamSessionId;

        const menuOptions = [
          {
            label: "Broadcast Setup",
            icon: <Settings size={14} />,
            action: () => onSettingsClick(stream),
          },
        ];

        return (
          <StreamThumbnailCard
            key={streamSessionId}
            stream={stream}
            image={getStreamImage(stream)}
            detail={getStreamDetailText(stream)}
            badgeLabel={getBadgeLabel(stream)}
            badgeVariant={getBadgeVariant(stream)}
            isLive={status === "live"}
            canPlay={canPlay}
            showPlayButton={canPlay}
            showMenuButton
            menuOptions={menuOptions}
            onClick={onCardClick}
            isOpen={Boolean(infoModalOpen)}
            onClose={onCloseInfoModal}
            modalTitle={getInfoModalTitle(stream)}
            modalMessage={getInfoModalMessage(stream)}
            modalMeta={getInfoModalMeta(stream)}
          />
        );
      })}
    </div>
  );
};

StreamVideosGrid.propTypes = {
  streams: PropTypes.array,
  selectedInfoStream: PropTypes.object,
  getStreamId: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
  canPlayStream: PropTypes.func.isRequired,
  getStreamImage: PropTypes.func.isRequired,
  getStreamDetailText: PropTypes.func.isRequired,
  getBadgeLabel: PropTypes.func.isRequired,
  getBadgeVariant: PropTypes.func.isRequired,
  getInfoModalTitle: PropTypes.func.isRequired,
  getInfoModalMessage: PropTypes.func.isRequired,
  getInfoModalMeta: PropTypes.func.isRequired,
  onCardClick: PropTypes.func.isRequired,
  onSettingsClick: PropTypes.func.isRequired,
  onCloseInfoModal: PropTypes.func.isRequired,
};

export default StreamVideosGrid;
